export default __webpack_public_path__ + "static/media/header-online-course-active-icon.0b57912f.svg";